import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { SalesPackage } from '../models/salespackage/salespackage.model';
import { ApiService } from '../shared/services/api.service';
import { LocalAccountService } from '../shared/services/localAccount.service';


@Injectable({
  providedIn: 'root'
})
export class SalesPackageService implements Resolve<any> {


  constructor(private api: ApiService,
    private localAccountService: LocalAccountService,
    private router: Router) {

  }

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    /*       if ((state.url.includes('common-area') && state.url.includes('subscription/') && state.url.includes('/detail')) ||
            (state.url.includes('administration-area') && state.url.includes('subjects/') && state.url.includes('/subscription/'))
          )  */

    if ((state.url.includes('common-area') && state.url.includes('salespackage/') && state.url.includes('/detail')) ||
      (state.url.includes('administration-area') && state.url.includes('subjects/') && state.url.includes('/subscription/'))
    ) {
      try {
        const resolved: any = {};
        let salespackageResponse: any;
        if (this.localAccountService.isAdmin() || this.localAccountService.isOperator()) {
          // subscriptionResponse = await this.getSubscription(route.params.subscriptionId);
        } else {
          salespackageResponse = await this.getSalespackageAllowed(route.params.salespackageId);
        }
        resolved.salespackage = salespackageResponse.payload;
        if (route.params.subjectId) {
          // const subjectResponse: any = await this.getSubject(route.params.subjectId);
          // resolved.subject = subjectResponse.payload;
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else {
      try {
        const resolved: any = {};
        // if (route.params.degreeCourseId == 'new') { // TODO LUIGI questa cosa credo non serva
        //   return resolved;
        // } else {
        // const degreeCourseResponse: any = await this.getDegreeCourse(route.params.degreeCourseId);
        // resolved.degreeCourse = degreeCourseResponse.payload;
        if (route.params.salespackageId && !(route.params.salespackageId === 'new')) {
          const subjectResponse: any = await this.getSalespakage(route.params.salespackageId);
          resolved.salespackage = subjectResponse.payload;
        }
        return resolved;
        // }
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    }
  }

  retrieveCourses(filterString, filterSoftskillCategoryId, pageIndex, pageSize, sortField, sortDirection) {
    if (!filterString) {
      filterString = ''
    };
    if (!pageIndex) {
      pageIndex = 0
    }
    if (!pageSize) {
      pageSize = 10
    }
    return this.api.getRequestPromise(`salespackage/list/paged?filterString=${filterString}&filterSoftskillCategoryId=${filterSoftskillCategoryId}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`);
  }

  async getSalespakage(id) {
    return this.api.getRequestPromise(`salespackage/${id}`);
  }

  async createSalespackage(obj) {
    return this.api.postRequestPromise(`salespackage`, obj);
  }

  deactivateSalespackage(id) {
    return this.api.putRequestPromise(`salespackage/${id}/deactivate`, {});
  }

  activateSalesPackage(id) {
    return this.api.putRequestPromise(`salespackage/${id}/activate`, {});
  }

  deleteSalesPackage(id) {
    return this.api.deleteRequestPromise(`salespackage/${id}/delete`);
  }

  async editSalespackage(obj) {
    return this.api.putRequestPromise(`salespackage`, obj);
  }

  retrieveSalespackageColor(salespackage: SalesPackage) {
    let ret;
    if (!salespackage.color) {
      ret = salespackage.frontEndSoftskillFacade.defaultAgendaColor;
    } else {
      ret = salespackage.color;
    }
    if (!ret) {
      ret = '#3c4252';
    }
    return ret;
  }

  retrieveSalespackageImageUrl(salespackage: SalesPackage) {
    let ret;
    if (salespackage.imageUrl) {
      ret = salespackage.imageUrl;
    } else {
      if (salespackage.frontEndSoftskillFacade.imageUrl) {
        ret = salespackage.frontEndSoftskillFacade.imageUrl;
      } else {
        ret = '/assets/images/exellente/placeholder_salespackage_card.jpg';
      }
    }
    return ret;
  }

  async getSalespackageAllowed(salespackageId) {
    // return this.api.getRequestPromise(`public/wp/salespackage/${salespackageId}`);
    return this.api.getRequestPromise(`public/salespackage/${salespackageId}`);
  }

  getAllowedSalespackageBySoftskill(softskillId) {
    // return this.api.getRequestPromise(`public/wp/salespackage?softskillId=${softskillId}`);
    return this.api.getRequestPromise(`public/salespackage?softskillId=${softskillId}`);
  }

  async getSalespackagesForEstimation(softskillId) {
    return this.api.getRequestPromise(`salespackage/list/${softskillId}/forEstimation`);
  }

}
